import { Injectable } from '@angular/core';
import { UserApi } from '@core/api';
import { UserPreferenceKeysEnum } from '@shared/enums';
import { UserPreferences, UserPreferencesPayload } from '@shared/interfaces/user-preferences.interface';
import { find } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class UserPreferencesService {
    private userPreferencesLocalStorageKey = 'userPreferences';
    private userPreferences: UserPreferences | null = null;

    constructor(private userApi: UserApi) {}

    setPreferences() {
        window.localStorage.setItem(this.userPreferencesLocalStorageKey, JSON.stringify(this.userPreferences));
    }

    getPreferenceValue(preferenceKey: UserPreferenceKeysEnum): undefined | boolean {
        if (!this.userPreferences) return undefined;
        return find(this.userPreferences.preferences, preference => {
            return preference.key === preferenceKey;
        })?.value;
    }

    initializeUserPreferences(preferences: UserPreferences): void {
        this.userPreferences = {
            userId: preferences.userId,
            preferences: preferences.preferences,
        };
        this.setPreferences();
    }

    async saveUserPreferences(newPreference: { key: UserPreferenceKeysEnum; value: boolean }) {
        if (!this.userPreferences) return;

        const replacePreferenceAtIndex = this.userPreferences.preferences.findIndex(
            preference => preference.key === newPreference.key
        );

        if (replacePreferenceAtIndex >= 0) {
            this.userPreferences.preferences.splice(replacePreferenceAtIndex, 1, newPreference);
        }

        const userPreferencePayload: UserPreferencesPayload = {
            showWelcomeModal: this.getPreferenceValue(UserPreferenceKeysEnum.SHOW_WELCOME_MODAL) ?? false,
            showOrderSetupByCsvGuide:
                this.getPreferenceValue(UserPreferenceKeysEnum.SHOW_ORDER_SETUP_BY_CSV_GUIDE) ?? false,
        };
        await this.userApi.saveUserPreferences(userPreferencePayload);
        this.setPreferences();
    }
}
